module.exports = __webpack_public_path__ + "static/media/yiyuan7.41d98a08.png";